import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import colors from '@/theme/colors';
import { css, cx } from '@emotion/css';

type FlyerDetailsNavBarProps = {
  onClick: () => void;
  iconPosition?: 'left' | 'right';
};

export const FlyerDetailsNavBar: React.FC<FlyerDetailsNavBarProps> = ({
  onClick,
  iconPosition = 'right',
}) => {
  const isLeftIcon = iconPosition === 'left';
  return (
    <div className={cx(styles.container, isLeftIcon ? styles.left : styles.right)}>
      <IconButton onClick={onClick} aria-label="Back button">
        {isLeftIcon ? <KeyboardArrowLeftIcon /> : <CloseOutlinedIcon />}
      </IconButton>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    z-index: 1199;
    position: sticky;
    transition: top 0.2s ease-out;
    width: 100%;
    background-color: ${colors.white};
    border-bottom: 1px solid ${colors.silver};
    min-height: 72px;
    svg {
      color: ${colors.prussian};
    }
  `,
  left: css`
    justify-content: flex-start;
    padding: 24px 0px 23px 8px;
  `,
  right: css`
    justify-content: flex-end;
    padding: 24px 20px 23px 0px;
  `,
};
